export default "Certificats d'Économies d'Énergie secteur BAT pour immeubles tertiaires ≥ 1 000 m² : BAT-TH (PAC, GTB, ECS solaire), BAT-EN (isolation), BAT-EQ (LED, variateurs). Levier-clé du plan -40 % OPERAT.";
